import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const container = document.getElementById("root");
const root = createRoot(container);

// グローバルなイベントリスナーを追加して、ブラウザのデフォルト挙動を無効化
document.addEventListener(
  "dragover",
  (e) => {
    e.preventDefault();
  },
  false
);

document.addEventListener(
  "drop",
  (e) => {
    e.preventDefault();
  },
  false
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

//index.js
